import { Terms as TermsContent } from 'supplemental-page-content';

import * as styles from './index.module.scss';

const Terms = () => (
  <div className={`${styles['privacy-container']}`}>
    <div className={`${styles['container']} container`}>
      <TermsContent domain="CallAPro.com" icon={() => {}} privacyUrl="/privacy" />
    </div>
  </div>
);

export default Terms;
